import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

/**
 * Determinate or indeterminate progress bar with a moving brand gradient.
 * Pass `value` 0–100 for determinate; omit for indeterminate.
 */
export default function ProgressBar({ value, className, indeterminate = false }) {
  return (
    <div
      className={cn('h-1.5 w-full overflow-hidden rounded-full bg-white/[0.06]', className)}
      role="progressbar"
      aria-valuenow={indeterminate ? undefined : value}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      {indeterminate ? (
        <motion.div
          className="h-full w-1/3 rounded-full bg-gradient-to-r from-brand-500 via-accent-cyan to-accent-fuchsia"
          animate={{ x: ['-100%', '320%'] }}
          transition={{ repeat: Infinity, duration: 1.2, ease: 'easeInOut' }}
        />
      ) : (
        <motion.div
          className="h-full rounded-full bg-gradient-to-r from-brand-500 via-accent-cyan to-accent-fuchsia"
          initial={{ width: 0 }}
          animate={{ width: `${Math.min(100, Math.max(0, value || 0))}%` }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      )}
    </div>
  );
}
